import React from 'react';
import ChatPreviewBox from './ChatPreviewBox';

export default function RightPanel() {
  return (
    <aside className="w-full min-w-[13rem] h-full bg-black p-3 flex flex-col gap-0 shrink-0">

      {/* Notifications */}
      <section>
        <h2 className="text-sm font-semibold mb-2">🔔 Notifications</h2>
        <ul className="text-xs text-gray-700 space-y-1">
          <li>📢 New client message</li>
          <li>✅ 2 portfolios reviewed</li>
        </ul>
      </section>

      {/* Trending Users */}
      <section>
        <h2 className="text-sm font-semibold mb-2">🔥 Trending Users</h2>
        <ul className="text-xs text-gray-700 space-y-1">
          <li>💼 @ProfitHunter</li>
          <li>📈 @XAUWizard</li>
        </ul>
      </section>

      {/* Market Watch */}
      <section>
        <h2 className="text-sm font-semibold mb-2">📊 Market Watch</h2>
        <ul className="text-xs text-gray-700 space-y-1">
          <li>🟢 Gold: <span className="font-medium text-green-600">$2,345.50</span></li>
          <li>🔴 EUR/USD: <span className="font-medium text-red-500">1.0821</span></li>
        </ul>
      </section>

      {/* Sponsored Promo */}
      <section className="bg-black p-2 rounded-md text-xs text-blue-800 border border-blue-200">
        <p>🚀 Promote your tools to 10K+ users!</p>
        <button className="mt-2 w-full px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">
          Create Promo
        </button>
      </section>

      {/* Chat Preview */}
      <ChatPreviewBox />
    </aside>
  );
}
